import { render } from "./ItemDetails.vue?vue&type=template&id=2c2f5707"
import script from "./ItemDetails.vue?vue&type=script&lang=js"
export * from "./ItemDetails.vue?vue&type=script&lang=js"

import "./ItemDetails.vue?vue&type=style&index=0&id=2c2f5707&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__